import {useState, useMemo, useCallback} from 'react'
import {getLocale} from 'localization/i18n'
import dayjs from 'services/utils/dayjs'

const usePurchasedDances = (purchasedDances) => {
    const {locale} = getLocale()
    const [searchValue, setSearchValue] = useState('')

    const getDanceName = useCallback(
        (dance) => {
            if (locale === 'he') {
                return dance?.nameHeb
            }
            return dance?.nameEng
        },
        [locale]
    )

    const getChoreographers = useCallback(
        (dance) => {
            if (locale === 'he') {
                return dance?.choreographersDisplayHeb
            }
            return dance?.choreographersDisplayEng
        },
        [locale]
    )

    const filteredData = useMemo(() => {
        if (!purchasedDances) return []
        if (!searchValue) return purchasedDances

        const searchLower = searchValue.toLowerCase()
        return purchasedDances.filter(({dance, created}) => {
            const danceName = getDanceName(dance)
            const choreographers = getChoreographers(dance)
            const purchaseDate = dayjs(created).format('DD/MM/YYYY')

            return (
                danceName?.toLowerCase().includes(searchLower) ||
                choreographers?.toLowerCase().includes(searchLower) ||
                purchaseDate?.includes(searchLower)
            )
        })
    }, [purchasedDances, searchValue, getDanceName, getChoreographers])

    return {
        searchValue,
        setSearchValue,
        filteredData,
        getDanceName,
        getChoreographers,
    }
}

export default usePurchasedDances
